

import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {
  constructor(private titleService: Title, private metaService: Meta) {}

  ngOnInit(): void {
    this.setSeoMeta();
    this.setSchema();
  }

  setSeoMeta() {
    this.titleService.setTitle($localize`:@@PRIVACY_POLICY.TITLE:MEDEIL Privacy Policy | Secure Data & User Information Practices`);

    this.metaService.updateTag({
      name: 'description',
      content: $localize`:@@PRIVACY_POLICY.DESCRIPTION:Review MEDEIL’s privacy policy to learn how we protect your personal data, ensure compliance, and keep your information secure across our POS solutions.`
    });

    this.metaService.updateTag({
      name: 'keywords',
      content: $localize`:@@PRIVACY_POLICY.KEYWORDS:Privacy policy, data privacy, user information, POS security, GDPR compliance, personal data protection, secure POS software, MEDEIL privacy`
    });

    this.metaService.updateTag({
      property: 'og:title',
      content: $localize`:@@PRIVACY_POLICY.OG_TITLE:MEDEIL Privacy Policy – Your Data Security & Rights | Medeil`
    });

    this.metaService.updateTag({
      property: 'og:description',
      content: $localize`:@@PRIVACY_POLICY.OG_DESCRIPTION:Review MEDEIL’s privacy policy to learn how we protect your personal data, ensure compliance, and keep your information secure across our POS solutions.`
    });

    this.metaService.updateTag({
      property: 'og:url',
      content: 'https://www.medeil.com/privacy-policy'
    });

    this.metaService.updateTag({
      property: 'og:type',
      content: 'website'
    });
  }

  setSchema() {
    const schema = {
      // "@context": "https://schema.org",
      // "@type": "WebPage",
      // "name": $localize`:@@PRIVACY_POLICY.SCHEMA_NAME:MEDEIL Privacy Policy – Your Data Security & Rights`,
      // "url": "https://www.medeil.com/privacy-policy",
      // "description": $localize`:@@PRIVACY_POLICY.SCHEMA_DESCRIPTION:Review MEDEIL’s privacy policy to learn how we protect your personal data, ensure compliance, and keep your information secure across our POS solutions.`,
      // "publisher": {
      //   "@type": "Organization",
      //   "name": "Medeil",
      //   "url": "https://www.medeil.com",
      //   "logo": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png"
      // }


  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": $localize`:@@PRIVACY_POLICY.SCHEMA_NAME:MEDEIL Privacy Policy | Secure Data & User Information Practices`,
  "description":$localize`:@@PRIVACY_POLICY.SCHEMA_DESCRIPTION:Review MEDEIL's privacy policy to learn how we protect your personal data, ensure compliance, and keep your information secure across our POS solutions.`,
  "url": "https://www.medeil.com/en/privacy-policy",
  "inLanguage": "en",
  "isPartOf": {
    "@type": "WebSite",
    "name": "MEDEIL",
    "url": "https://www.medeil.com"
  },
  "publisher": {
    "@type": "Organization",
    "name": "MEDEIL",
    "url": "https://www.medeil.com",
    "logo": {
      "@type": "ImageObject",
      "url": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png"
    }
  },
  "breadcrumb": {
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://www.medeil.com/en"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Privacy Policy",
        "item": "https://www.medeil.com/en/privacy-policy"
      }
    ]
  },
  "mainEntity": {
    "@type": "WebContent",
    "about": {
      "@type": "Thing",
      "name": "Privacy Policy",
      "description": "Information about how MEDEIL handles user data and ensures privacy"
    },
    "datePublished": "2024-01-01",
    "dateModified": "2024-05-08"
  }
    };

    const script = document.createElement('script');
    script.setAttribute('type', 'application/ld+json');
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
  }
}





// import { Component, OnInit } from '@angular/core';
// import { Meta, Title } from '@angular/platform-browser';

// @Component({
//   selector: 'app-privacy-policy',
//   templateUrl: './privacy-policy.component.html',
//   styleUrls: ['./privacy-policy.component.scss']
// })
// export class PrivacyPolicyComponent implements OnInit {
//   constructor(private titleService: Title, private metaService: Meta) {}

//   ngOnInit(): void {
//     this.setSeoMeta();
//     this.setSchema();
//   }

//   setSeoMeta() {
//     this.titleService.setTitle('');
//     this.metaService.updateTag({ name: 'description', content: 'Review MEDEIL’s privacy policy to learn how we protect your personal data, ensure compliance, and keep your information secure across our POS solutions. Our MEDEIL Privacy Policy – Your Data Security & Rights explains how we collect, use, and protect your information in compliance with global healthcare standards.' });
//     this.metaService.updateTag({ name: 'keywords', content: 'Privacy policy, data privacy, user information, POS security, GDPR compliance, personal data protection, secure POS software, MEDEIL privacy' });
//     this.metaService.updateTag({ property: 'og:title', content: 'MEDEIL Privacy Policy – Your Data Security & Rights | Medeil' });
//     this.metaService.updateTag({ property: 'og:description', content: 'Review MEDEIL’s privacy policy to learn how we protect your personal data, ensure compliance, and keep your information secure across our POS solutions.' });
//     this.metaService.updateTag({ property: 'og:url', content: 'https://www.medeil.com/privacy-policy' });
//     this.metaService.updateTag({ property: 'og:type', content: 'website' });
//   }

//   setSchema() {
//     const schema = {
//       "@context": "https://schema.org",
//       "@type": "WebPage",
//       "name": "MEDEIL Privacy Policy – Your Data Security & Rights",
//       "url": "https://www.medeil.com/privacy-policy",
//       "description": "Review MEDEIL’s privacy policy to learn how we protect your personal data, ensure compliance, and keep your information secure across our POS solutions.",
//       "publisher": {
//         "@type": "Organization",
//         "name": "Medeil",
//         "url": "https://www.medeil.com",
//         "logo": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png"
//       }
//     };

//     const script = document.createElement('script');
//     script.setAttribute('type', 'application/ld+json');
//     script.textContent = JSON.stringify(schema);
//     document.head.appendChild(script);
//   }
// }
